import { render, staticRenderFns } from "./AwaitingPaymentModal.vue?vue&type=template&id=15f96d85"
import script from "./AwaitingPaymentModal.vue?vue&type=script&lang=ts"
export * from "./AwaitingPaymentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f96d85')) {
      api.createRecord('15f96d85', component.options)
    } else {
      api.reload('15f96d85', component.options)
    }
    module.hot.accept("./AwaitingPaymentModal.vue?vue&type=template&id=15f96d85", function () {
      api.rerender('15f96d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AwaitingPaymentModal.vue"
export default component.exports